// @flow

import { pendingActions } from 'common/pending-actions'

export const pushInterest = ($button: JQuery) => {
  const interest = $button.attr('data-interest')

  if (!interest) {
    return
  }

  pendingActions.addUserInterests({ disciplineId: Number(interest), reason: 'project_landing_cta_clicked' })
}
